export class CdcBackupModeCheckResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "CdcBackupModeCheckResultModeEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CdcBackupModeCheckResult.attributeTypeMap;
    }
    constructor() {
    }
}
export var CdcBackupModeCheckResultModeEnum;
(function (CdcBackupModeCheckResultModeEnum) {
    CdcBackupModeCheckResultModeEnum["None"] = "NONE";
    CdcBackupModeCheckResultModeEnum["Cdc"] = "CDC";
    CdcBackupModeCheckResultModeEnum["CdcReaderOnly"] = "CDC_READER_ONLY";
})(CdcBackupModeCheckResultModeEnum || (CdcBackupModeCheckResultModeEnum = {}));
